'use strict';
require('./url-search-params');
require('../modules/web.url');
require('../modules/web.url.can-parse');
require('../modules/web.url.to-json');
var path = require('../internals/path');

module.exports = path.URL;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/web/url.js
// module id = 0/Zu
// module chunks = 0